const generateTestId = (title: string, component: string) => {
    return `${title
        .trim()
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]/g, " ")
        .replace(/\s+/g, "-")}-${component}`;
};

export default generateTestId;
